// extracted by mini-css-extract-plugin
export default {"shell":"Layout_shell__R3AlY","main":"Layout_main__ewt4V","fullWidth":"Layout_fullWidth__V+tZ1","containerResponsive":"Layout_containerResponsive__HeX9x"};